export interface ReportUploadOutput {
	patientId: string;
	type: string;
	device: string;
	serviceLine: string;
	alert: string;
	file: File;
}
